/* 
* Dynamic src swap 
* It will identify the breakpoint set and change src accordingly
*
* Usage ----------------------------------------------
* Import dynamicSrc from "./dynamic-src/dynamic-src";
* dynamicSrc.render(source) call the render function and pass the source
* Requires lib.js
*
*/

import lib from "../lib/lib";

const dynamicSrc = {
    render: (source) => {
        const breakpoint = 600;
        let elems = lib.qsa(source);
         
        if(lib.windowWidth() >= breakpoint) {
           // Is Desktop
            elems.forEach((elem) => {
                elem.setAttribute('src', elem.getAttribute('data-desktop-src'));
            });
        } else {
            // Is Mobile
            elems.forEach((elem) => {
                elem.setAttribute('src', elem.getAttribute('data-mobile-src'));
            });
        }
    }
}

export { dynamicSrc as default }